module.exports = __webpack_public_path__ + "img/cover.5906d0f8.jpg";